import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIGeneral() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ol className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ol>
								<h1 className="page-header">
									{'General '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="alert" className="mb-5">
									<h4>{'Alerts'}</h4>
									<p>
										{' Wrap any text and an optional dismiss button in '}
										<code>{'.alert'}</code>
										{
											' and one of the four contextual classes for basic alert messages. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/alerts/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options. '}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="alert alert-primary">
												<strong>{'Primary!'}</strong>
												{' A simple primary alert check it out! '}
											</div>
											<div className="alert alert-secondary">
												<strong>{'Secondary Alert!'}</strong>
												{" This alert is not important, but it's beautiful."}
											</div>
											<div className="alert alert-success">
												<strong>{'Well done!'}</strong>
												{' You successfully read this important alert message. '}
											</div>
											<div className="alert alert-danger">
												<strong>{'Oh snap!'}</strong>
												{' Change a few things up and try submitting again. '}
											</div>
											<div className="alert alert-warning">
												<strong>{'Warning!'}</strong>
												{" Better check yourself, you're not looking too good."}
											</div>
											<div className="alert alert-info">
												<strong>{'Heads up!'}</strong>
												{" This alert needs your attention, but it's not super important."}
											</div>
											<div className="alert alert-dark">
												<strong>{'Dark!'}</strong>
												{' A simple dark alert—check it out! '}
											</div>
											<div className="alert alert-light mb-0">
												<strong>{'Light!'}</strong>
												{' A simple light alert—check it out! '}
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="badge" className="mb-5">
									<h4>{'Badges'}</h4>
									<p>
										{
											'Documentation and examples for badges, our small count and labeling component. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/badge/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div>
												<span className="badge bg-primary">{'Primary'}</span>
												<span className="badge bg-secondary">{'Secondary'}</span>
												<span className="badge bg-success">{'Success'}</span>
												<span className="badge bg-danger">{'Danger'}</span>
												<span className="badge bg-warning">{'Warning'}</span>
												<span className="badge bg-info">{'Info'}</span>
												<span className="badge bg-light text-dark">{'Light'}</span>
												<span className="badge bg-dark">{'Dark'}</span>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-2.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="breadcrumb" className="mb-5">
									<h4>{'Breadcrumb'}</h4>
									<p>
										{
											'Indicate the current page’s location within a navigational hierarchy that automatically adds separators via CSS. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/breadcrumb/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<ol className="breadcrumb">
												<li className="breadcrumb-item">
													<a href="#/">{'Home'}</a>
												</li>
												<li className="breadcrumb-item">
													<a href="#/">{'Library'}</a>
												</li>
												<li className="breadcrumb-item active">{'Data'}</li>
											</ol>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-3.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="carousel" className="mb-5">
									<h4>{'Carousel'}</h4>
									<p>
										{
											'A slideshow component for cycling through elements—images or slides of text—like a carousel. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/carousel/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div
												id="carouselExample"
												className="carousel slide"
												data-ride="carousel"
												data-bs-theme="dark"
											>
												<div className="carousel-indicators">
													<button
														type="button"
														data-bs-target="#carouselExample"
														data-bs-slide-to="0"
														className="active"
														aria-current="true"
														aria-label="Slide 1"
													></button>
													<button
														type="button"
														data-bs-target="#carouselExample"
														data-bs-slide-to="1"
														aria-label="Slide 2"
													></button>
													<button
														type="button"
														data-bs-target="#carouselExample"
														data-bs-slide-to="2"
														aria-label="Slide 3"
													></button>
												</div>
												<div className="carousel-inner">
													<div className="carousel-item active">
														<img
															src="https://placehold.co/728x400/dee2e6/161a1d"
															alt=""
															className="d-block w-100"
														/>
														<div className="carousel-caption d-none d-md-block">
															<h5>{'First slide label'}</h5>
															<p>
																{
																	'Nulla vitae elit libero, a pharetra augue mollis interdum.'
																}
															</p>
														</div>
													</div>
													<div className="carousel-item">
														<img
															src="https://placehold.co/728x400/dee2e6/161a1d"
															alt=""
															className="d-block w-100"
														/>
														<div className="carousel-caption d-none d-md-block">
															<h5>{'Second slide label'}</h5>
															<p>
																{
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
																}
															</p>
														</div>
													</div>
													<div className="carousel-item">
														<img
															src="https://placehold.co/728x400/dee2e6/161a1d"
															alt=""
															className="d-block w-100"
														/>
														<div className="carousel-caption d-none d-md-block">
															<h5>{'Third slide label'}</h5>
															<p>
																{
																	'Praesent commodo cursus magna, vel scelerisque nisl consectetur.'
																}
															</p>
														</div>
													</div>
												</div>
												<a
													className="carousel-control-prev"
													href="#carouselExample"
													data-bs-slide="prev"
												>
													<span className="carousel-control-prev-icon"></span>
												</a>
												<a
													className="carousel-control-next"
													href="#carouselExample"
													data-bs-slide="next"
												>
													<span className="carousel-control-next-icon"></span>
												</a>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-4.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="jumbotron" className="mb-5">
									<h4>{'Jumbotron'}</h4>
									<p>
										{
											'Lightweight, flexible component for showcasing hero unit style content by using Bootstrap utilities.'
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="p-5 bg-light-subtle mb-0 rounded-3">
												<h1 className="display-5 fw-bold">{'Hello, world!'}</h1>
												<p className="lead">
													{
														'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.'
													}
												</p>
												<hr className="my-4" />
												<p>
													{
														'It uses utility classes for typography and spacing to space content out within the larger container.'
													}
												</p>
												<a className="btn btn-theme btn-lg" href="#/" role="button">
													{'Learn more'}
												</a>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-5.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="listGroup" className="mb-5">
									<h4>{'List Group'}</h4>
									<p>
										{
											'List groups are a flexible and powerful component for displaying a series of content. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/list-group/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row">
												<div className="col-xl-6">
													<div className="list-group">
														<a
															href="#/"
															className="list-group-item list-group-item-action active"
														>
															{'Cras justo odio'}
														</a>
														<a href="#/" className="list-group-item list-group-item-action">
															{'Dapibus ac facilisis in'}
														</a>
														<a href="#/" className="list-group-item list-group-item-action">
															{'Morbi leo risus'}
														</a>
														<a href="#/" className="list-group-item list-group-item-action">
															{'Porta ac consectetur ac'}
														</a>
														<a
															href="#/"
															className="list-group-item list-group-item-action disabled"
														>
															{'Vestibulum at eros'}
														</a>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-6.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="mediaObject" className="mb-5">
									<h4>{'Media Object'}</h4>
									<p>
										{
											'Media object is created by using Bootstrap utilities class and it is construct highly repetitive components like blog comments, tweets, and the like.'
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="d-flex align-items-start">
												<img
													src="https://placehold.co/128x128/dee2e6/161a1d"
													alt=""
													width="64"
													className="rounded"
												/>
												<div className="ms-3">
													<h5 className="mt-0 mb-1">{'Media heading'}</h5>
													{
														' Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus. '
													}
													<div className="d-flex align-items-start mt-3">
														<a href="#/">
															<img
																src="https://placehold.co/128x128/dee2e6/161a1d"
																alt=""
																width="64"
																className="rounded"
															/>
														</a>
														<div className="ms-3">
															<h5 className="mt-0 mb-1">{'Media heading'}</h5>
															{
																' Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus. '
															}
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-7.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="navs" className="mb-5">
									<h4>{'Navs'}</h4>
									<p>
										{
											'Navigation available in Bootstrap share general markup and styles, from the base .nav class to the active and disabled states. Swap modifier classes to switch between each style. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/navs/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row">
												<div className="col-xl-6 mb-xl-0 mb-3">
													<div className="mb-2 small text-body text-opacity-75">
														<b className="fw-bold">{'BASE NAV'}</b>
													</div>
													<nav className="nav mb-4">
														<a className="nav-link active" href="#/">
															{'Active'}
														</a>
														<a className="nav-link" href="#/">
															{'Link'}
														</a>
														<a className="nav-link" href="#/">
															{'Link'}
														</a>
														<a className="nav-link disabled" href="#/">
															{'Disabled'}
														</a>
													</nav>
													<div className="mb-2 small text-body text-opacity-75">
														<b className="fw-bold">{'UNDERLINE NAV'}</b>
													</div>
													<nav className="nav nav-underline mb-3">
														<a className="nav-link ms-3 active" href="#/">
															{'Active'}
														</a>
														<a className="nav-link ms-3" href="#/">
															{'Link'}
														</a>
														<a className="nav-link ms-3" href="#/">
															{'Link'}
														</a>
														<a className="nav-link ms-3 disabled" href="#/">
															{'Disabled'}
														</a>
													</nav>
												</div>
												<div className="col-xl-6">
													<div className="mb-2 small text-body text-opacity-75">
														<b className="fw-bold">{'VERTICAL NAV'}</b>
													</div>
													<nav className="nav flex-column">
														<a className="nav-link active" href="#/">
															{'Active'}
														</a>
														<a className="nav-link" href="#/">
															{'Link'}
														</a>
														<a className="nav-link" href="#/">
															{'Link'}
														</a>
														<a className="nav-link disabled" href="#/">
															{'Disabled'}
														</a>
													</nav>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-8.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="navbar" className="mb-5">
									<h4>{'Narbar'}</h4>
									<p>
										{
											'Includes support for branding, navigation, and more, including support for collapse plugin. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/navbar/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<nav
												className="navbar navbar-expand-lg bg-light mb-3 rounded theme-primary"
												data-bs-theme="light"
											>
												<div className="container-fluid">
													<button
														className="navbar-toggler"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#navbarLight"
													>
														<span className="navbar-toggler-icon"></span>
													</button>
													<div className="collapse navbar-collapse" id="navbarLight">
														<a className="navbar-brand px-2 fw-bold" href="#/">
															{'Navbar'}
														</a>
														<ul className="navbar-nav me-auto mt-2 mt-lg-0">
															<li className="nav-item active">
																<a className="nav-link" href="#/">
																	{'Home'}
																</a>
															</li>
															<li className="nav-item">
																<a className="nav-link" href="#/">
																	{'Link'}
																</a>
															</li>
															<li className="nav-item">
																<a className="nav-link disabled" href="#/">
																	{'Disabled'}
																</a>
															</li>
														</ul>
														<form className="d-flex">
															<input
																className="form-control me-sm-2"
																type="search"
																placeholder="Search"
															/>
															<button
																className="btn btn-outline-theme my-2 my-sm-0"
																type="submit"
															>
																{'Search'}
															</button>
														</form>
													</div>
												</div>
											</nav>
											<nav
												className="navbar navbar-expand-lg bg-gray-900 rounded theme-info"
												data-bs-theme="dark"
											>
												<div className="container-fluid">
													<button
														className="navbar-toggler"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#navbarDark"
													>
														<span className="navbar-toggler-icon"></span>
													</button>
													<div className="collapse navbar-collapse" id="navbarDark">
														<a className="navbar-brand px-2 fw-bold" href="#/">
															{'Navbar'}
														</a>
														<ul className="navbar-nav me-auto mt-2 mt-lg-0">
															<li className="nav-item active">
																<a className="nav-link" href="#/">
																	{'Home'}
																</a>
															</li>
															<li className="nav-item">
																<a className="nav-link" href="#/">
																	{'Link'}
																</a>
															</li>
															<li className="nav-item">
																<a className="nav-link disabled" href="#/">
																	{'Disabled'}
																</a>
															</li>
														</ul>
														<form className="d-flex">
															<input
																className="form-control me-sm-2"
																type="search"
																placeholder="Search"
															/>
															<button
																className="btn btn-outline-info my-2 my-sm-0"
																type="submit"
															>
																{'Search'}
															</button>
														</form>
													</div>
												</div>
											</nav>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-9.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="pagination" className="mb-5">
									<h4>{'Pagination'}</h4>
									<p>
										{
											'Documentation and examples for showing pagination to indicate a series of related content exists across multiple pages. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/pagination/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<ul className="pagination mb-0">
												<li className="page-item disabled">
											<a className="page-link" href="#/">{'Previous'}</a>
												</li>
												<li className="page-item">
													<a className="page-link" href="#/">
														{'1'}
													</a>
												</li>
												<li className="page-item active">
													<a className="page-link" href="#/">
														{'2'}
													</a>
												</li>
												<li className="page-item">
													<a className="page-link" href="#/">
														{'3'}
													</a>
												</li>
												<li className="page-item">
													<a className="page-link" href="#/">
														{'Next'}
													</a>
												</li>
											</ul>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-10.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="progress" className="mb-5">
									<h4>{'Progress'}</h4>
									<p>
										{
											'Documentation and examples for using Bootstrap custom progress bars featuring support for stacked bars, animated backgrounds, and text labels. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/progress/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row">
												<div className="col-xl-6">
													<div className="mb-3">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'DEFAULT'}</b>
														</div>
														<div className="progress fw-bold">
															<div className="progress-bar" style={{ width: '50%' }}>
																{'50%'}
															</div>
														</div>
													</div>
													<div className="mb-3">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'MULTIPLE BARS'}</b>
														</div>
														<div className="progress fw-bold">
															<div className="progress-bar" style={{ width: '33%' }}>
																{'33%'}
															</div>
															<div
																className="progress-bar bg-warning"
																style={{ width: '20%' }}
															>
																{'20%'}
															</div>
															<div
																className="progress-bar bg-danger"
																style={{ width: '20%' }}
															>
																{'20%'}
															</div>
														</div>
													</div>
												</div>
												<div className="col-xl-6">
													<div className="mb-3">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'STRIPED'}</b>
														</div>
														<div className="progress fw-bold">
															<div
																className="progress-bar progress-bar-striped"
																style={{ width: '66%' }}
															>
																{'66%'}
															</div>
														</div>
													</div>
													<div className="mb-3">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'ANIMATED'}</b>
														</div>
														<div className="progress fw-bold">
															<div
																className="progress-bar progress-bar-striped progress-bar-animated bg-success"
																style={{ width: '33%' }}
															>
																{'33%'}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-11.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="spinners" className="mb-5">
									<h4>{'Spinners'}</h4>
									<p>
										{
											'Indicate the loading state of a component or page with Bootstrap spinners, built entirely with HTML, CSS, and no JavaScript. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.1/components/spinners/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body pb-0">
											<div className="row">
												<div className="col-xl-6">
													<div className="mb-4">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'BORDER SPINNER'}</b>
														</div>
														<div className="spinner-border"></div>
													</div>
													<div className="mb-4">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'COLORS'}</b>
														</div>
														<div className="spinner-border text-primary"></div>
														<div className="spinner-border text-secondary"></div>
														<div className="spinner-border text-success"></div>
														<div className="spinner-border text-danger"></div>
														<div className="spinner-border text-warning"></div>
														<div className="spinner-border text-info"></div>
														<div className="spinner-border text-light"></div>
														<div className="spinner-border text-dark"></div>
													</div>
													<div className="mb-4">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'SIZE'}</b>
														</div>
														<div className="spinner-border spinner-border-sm"></div>
														<div className="spinner-border spinner-border-sm text-primary"></div>
													</div>
												</div>
												<div className="col-xl-6">
													<div className="mb-4">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'GROWING SPINNER'}</b>
														</div>
														<div className="spinner-grow"></div>
													</div>
													<div className="mb-4">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'COLORS'}</b>
														</div>
														<div className="spinner-grow text-primary"></div>
														<div className="spinner-grow text-secondary"></div>
														<div className="spinner-grow text-success"></div>
														<div className="spinner-grow text-danger"></div>
														<div className="spinner-grow text-warning"></div>
														<div className="spinner-grow text-info"></div>
														<div className="spinner-grow text-light"></div>
														<div className="spinner-grow text-dark"></div>
													</div>
													<div className="mb-4">
														<div className="mb-2 small text-body text-opacity-75">
															<b className="fw-bold">{'SIZE'}</b>
														</div>
														<div className="spinner-grow spinner-grow-sm"></div>
														<div className="spinner-grow spinner-grow-sm text-primary"></div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-12.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="placeholders" className="mb-5">
									<h4>{'Placeholders'}</h4>
									<p>
										{
											'Use loading placeholders (skeleton loaders) for your components or pages to indicate something may still be loading. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/placeholders/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row gy-3">
												<div className="col-lg-6">
													<div className="card overflow-hidden">
														<div className="card-img-top h-150px bg-gray-400 rounded-0"></div>
														<div className="card-body">
															<h5 className="card-title placeholder-glow">
																<span className="placeholder placeholder-lg col-6 bg-gray-500"></span>
															</h5>
															<p className="card-text placeholder-glow">
																<span className="placeholder placeholder-sm col-7 bg-gray-500 me-2"></span>
																<span className="placeholder placeholder-sm col-4 bg-gray-500 me-2"></span>
																<span className="placeholder placeholder-sm col-4 bg-gray-500 me-2"></span>
																<span className="placeholder placeholder-sm col-6 bg-gray-500 me-2"></span>
																<span className="placeholder placeholder-sm col-8 bg-gray-500 me-2"></span>
															</p>
					<a
						className="btn btn-primary bg-gray-500 border-gray-500 disabled placeholder col-6"
						aria-disabled="true"
						href="#/"
						aria-label="Placeholder action"
					></a>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-13.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="offcanvas" className="mb-5">
									<h4>{'Offcanvas'}</h4>
									<p>
										{
											'Build hidden sidebars into your project for navigation, shopping carts, and more with a few classes and our JavaScript plugin. Please read the '
										}
										<a
											href="https://getbootstrap.com/docs/5.3/components/offcanvas/"
											target="_blank" rel="noreferrer"
										>
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row">
												<div className="col-lg-6">
													<div className="form-label">{'Default'}</div>
													<div>
														<button
															type="button"
															className="btn btn-primary"
															data-bs-toggle="offcanvas"
															href="#offcanvasStartExample"
														>
															<i className="far fa-hand-point-up fa-fw mx-1 opacity-5"></i>
															{' Offcanvas Demo '}
														</button>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-label">{'Placement'}</div>
													<div className="btn-group">
														<a
															className="btn btn-default"
															data-bs-toggle="offcanvas"
															href="#offcanvasEndExample"
														>
															<i className="fa fa-arrow-right fa-fw mx-1 opacity-5"></i>
															{' Right '}
														</a>
														<a
															className="btn btn-default"
															data-bs-toggle="offcanvas"
															href="#offcanvasBottomExample"
														>
															<i className="fa fa-arrow-down fa-fw mx-1 opacity-5"></i>
															{' Bottom '}
														</a>
													</div>
												</div>
											</div>
										</div>
										<div className="card-body bg-gray-500">
											<div
												className="offcanvas offcanvas-start position-static visible"
												id="offcanvas"
												data-bs-backdrop="false"
												data-bs-scroll="true"
												style={{ transform: 'none' }}
											>
												<div className="offcanvas-header">
													<h5 className="offcanvas-title" id="offcanvasLabel">
														{'Offcanvas'}
													</h5>
													<button type="button" className="btn-close text-reset"></button>
												</div>
												<div className="offcanvas-body">
													{
														' Content for the offcanvas goes here. You can place just about any Bootstrap component or custom elements here. '
													}
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-general/code-14.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#alert" data-toggle="scroll-to">
											{'Alert'}
										</a>
										<a className="nav-link" href="#badge" data-toggle="scroll-to">
											{'Badge'}
										</a>
										<a className="nav-link" href="#breadcrumb" data-toggle="scroll-to">
											{'Breadcrumb'}
										</a>
										<a className="nav-link" href="#carousel" data-toggle="scroll-to">
											{'Carousel'}
										</a>
										<a className="nav-link" href="#jumbotron" data-toggle="scroll-to">
											{'Jumbotron'}
										</a>
										<a className="nav-link" href="#listGroup" data-toggle="scroll-to">
											{'List group'}
										</a>
										<a className="nav-link" href="#mediaObject" data-toggle="scroll-to">
											{'Media object'}
										</a>
										<a className="nav-link" href="#navs" data-toggle="scroll-to">
											{'Navs'}
										</a>
										<a className="nav-link" href="#navbar" data-toggle="scroll-to">
											{'Navbar'}
										</a>
										<a className="nav-link" href="#pagination" data-toggle="scroll-to">
											{'Pagination'}
										</a>
										<a className="nav-link" href="#progress" data-toggle="scroll-to">
											{'Progress'}
										</a>
										<a className="nav-link" href="#spinners" data-toggle="scroll-to">
											{'Spinners'}
										</a>
										<a className="nav-link" href="#placeholders" data-toggle="scroll-to">
											{'Placeholders'}
										</a>
										<a className="nav-link" href="#offcanvas" data-toggle="scroll-to">
											{'Offcanvas'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UIGeneral;
